export default __webpack_public_path__ + "static/media/Lora-SemiBold.dfac657f.ttf";